// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"ColorPicker_colorPicker__bC0VO","colorButton":"ColorPicker_colorButton__q_ZZW","selected":"ColorPicker_selected__llTv6"};